import { useMemo } from "react"
import { useQuery } from "@oysterhr/core"
import { FeatureFlags, FeatureFlagsResponse } from "./types"
import { convertFeatureFlagEnumToFeatureFlagKey } from "./utils"
import { gql } from "@apollo/client"

export const FEATURE_FLAGS_QUERY = gql`
  query FeatureFlags($actorId: ID) {
    featureFlags(actorId: $actorId)
  }
`

export function useFeatureFlags(actorId: string): FeatureFlags {
  const { data, error } = useQuery<FeatureFlagsResponse>(FEATURE_FLAGS_QUERY, {
    variables: {
      actorId,
    },
  })

  if (error) {
    throw error
  }

  const flags = useMemo(() => ({}) as FeatureFlags, [])

  useMemo(() => {
    return data?.featureFlags.reduce((obj, flag) => {
      obj[convertFeatureFlagEnumToFeatureFlagKey(flag)] = true
      return obj
    }, flags)
  }, [flags, data?.featureFlags])

  return flags
}
